import { render, staticRenderFns } from "./ArticleRubricList.component.vue?vue&type=template&id=3f259582&scoped=true"
import script from "./ArticleRubricList.component.vue?vue&type=script&lang=ts"
export * from "./ArticleRubricList.component.vue?vue&type=script&lang=ts"
import style0 from "./ArticleRubricList.component.vue?vue&type=style&index=0&id=3f259582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f259582",
  null
  
)

export default component.exports